<template>
  <el-main>
    <FloatWarning
      v-if="!fakeState"
      :deviceStates="deviceStates">
    </FloatWarning>
    <TabPages></TabPages>
  </el-main>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TabPages from '@/components/TabPages';
import FloatWarning from '@/components/warnings/FloatWarning';

export default {
  components: {
    TabPages,
    FloatWarning,
  },
  computed: {
    ...mapState('device', ['deviceStates']),
    ...mapGetters('admin', ['fakeState']),
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 992px) {
  .el-main {
    padding: 20px 0;
  }
}
</style>
